import { useAppSelector } from '../../redux/app/hooks';
import { RootState } from '../../redux/app/store';

export const useRole = () => {
    const roles = useAppSelector((state: RootState) => state.app.userRoles); // <- from global store

    const hasRole = (requiredRoles: string | string[]): boolean => {
        const list = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles];
        return list.some((role) => roles.includes(role));
    };

    const doesNotHaveRole = (requiredRoles: string | string[]) => !hasRole(requiredRoles);

    const hasAnyRole = (roleList: string[]) => roleList.some((r) => roles.includes(r));

    return { hasRole, doesNotHaveRole, hasAnyRole };
};
